import React from "react";
import FieldRow from "../FieldRow";
import ProductsList from "../ProductsList";

export default function ReceiptResultCard({ item, isExpanded, onCopy }) {
  const products = item.products || [];

  return (
    <>
      <div style={{ display: "grid", gap: "0.25rem", marginTop: "0.4rem" }}>
        <FieldRow label="ID" value={item.id} onCopy={onCopy} />
        <FieldRow label="Номер квитанции" value={item.receipt_number} onCopy={onCopy} />
        <FieldRow label="ID маршрута" value={item.routeListId} onCopy={onCopy} />
        <FieldRow label="Клиент" value={item.client_name} onCopy={onCopy} />
        <FieldRow label="Договор" value={item.contract_number} onCopy={onCopy} />
        <FieldRow label="Адрес" value={item.delivery_address} onCopy={onCopy} />
        <FieldRow label="Телефон" value={item.phone_number} onCopy={onCopy} />
        <FieldRow label="Время" value={item.time} onCopy={onCopy} />
        <FieldRow label="Статус" value={item.status} onCopy={onCopy} />
        <FieldRow label="Сумма" value={item.amount} onCopy={onCopy} />
        <FieldRow label="Тип оплаты" value={item.payment_type} onCopy={onCopy} />
      </div>

      <div
        style={{
          marginTop: "0.6rem",
          fontSize: "0.8rem",
          color: "#64748b",
        }}
      >
        Товаров: <strong>{products.length}</strong>
      </div>

      {isExpanded && products.length > 0 && (
        <div
          style={{
            marginTop: "0.6rem",
            borderTop: "1px solid #e2e8f0",
            paddingTop: "0.5rem",
          }}
        >
          <ProductsList products={products} onCopy={onCopy} />
        </div>
      )}
    </>
  );
}
